// extracted by mini-css-extract-plugin
export default {"inner":"Preview_inner__qlI3R","title":"Preview_title__y5Hx1","close":"Preview_close__nej6F","card":"Preview_card__JR8Xu"};